import { Component, OnInit } from '@angular/core';
import { UserAuthService } from 'src/app/auth/user-auth.service';
import { Router, ActivatedRoute, RoutesRecognized, ChildActivationEnd, NavigationEnd, NavigationStart } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Location, LocationStrategy } from '@angular/common';
import { faChevronLeft, faCalendar, faUsers, IconDefinition, faSignOut, faCog } from '@fortawesome/free-solid-svg-icons';
import { RSFirebaseService } from 'src/app/services/rsfirebase.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Subscription } from 'rxjs';

export class Page {
  
  title: string;
  path: string;
  icon: IconDefinition;
  constructor(t: string, p: string, i: IconDefinition){
    this.title = t;
    this.path = p;
    this.icon = i;
  }
}

@Component({
  selector: 'ubc-logged-in-nav',
  templateUrl: './logged-in-nav.component.html',
  styleUrls: ['./logged-in-nav.component.scss']
})
export class LoggedInNavComponent implements OnInit {
  currentPageUrl: string;
  mobileMenuOpen = false;
  pages: Page[] = [
    new Page('CALENDAR', '/calendar', faCalendar),
    //new Page('USERS', '/users'),
    new Page('CUSTOMERS', '/customers', faUsers),
    new Page('SETTINGS', '/settings', faCog), 
  ];

  private routerSub!: Subscription
  
  constructor(
    public userAuthService: UserAuthService,
    private router: Router,
    private location: Location,
    locStrategy: LocationStrategy,
    public rsFirebaseService: RSFirebaseService,
    private afAuth: AngularFireAuth
    ) {
      // locStrategy.onPopState(() => {
      //   console.log('POPPED');

      //   return false;
      // })
    }

  faChevronLeft = faChevronLeft;
  faSignOut = faSignOut
  backDisabled = false;
  ngOnInit() {
    this.subscribeToNavChanges();
    
    
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }

  signOut() {
    this.afAuth.signOut()
  }

  mobileMenuToggle() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }


  subscribeToNavChanges() {
    setTimeout(() => {
      console.log("initialUrl", initialUrl, this.userAuthService.loggedIn)
    }, 3000)
    const initialUrl = this.router.url;
    
    if (initialUrl === '/' && this.userAuthService.loggedIn) {
      this.router.navigate(['/calendar'])
    }

    this.routerSub = this.router.events.pipe(
      filter(evt => evt instanceof NavigationEnd),
      map((evt: NavigationEnd) => evt.urlAfterRedirects)
    ).subscribe(url => {
      this.currentPageUrl = url;
      this.mobileMenuOpen = false
      if (url === '/' && this.userAuthService.loggedIn) {
        // use navigate to keep things consistent
        this.router.navigate(['/calendar']);
      }
    });


  }

  goBack(){
    // console.log('Back clicked');
    this.location.back();
  }

  pageIsCurrent(page: Page): boolean {
    return (this.currentPageUrl === page.path);
  }

  navigateToPage(page: Page) {
    if(this.currentPageUrl === page.path) {
      return;
    }
    this.router.navigateByUrl(page.path);
  }

}
